import { render, staticRenderFns } from "./SaleTypeEditName.vue?vue&type=template&id=2f1dba36&scoped=true"
import script from "./SaleTypeEditName.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1dba36",
  null
  
)

export default component.exports